import React from "react";

export default class DashboardTitle extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

        };
    }

    render() {

        return(
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: -20, marginLeft: 10 }}>
                <img src={this.props.icon} alt="" style={{ width: 30, height: 30 }} />
                <h2 style={{ marginLeft: 20, fontWeight: 'bold', marginTop: 25 }}>{this.props.title}</h2>
            </div>
        );
    }
}